var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "header",
        { staticClass: "header" },
        [
          _c(
            "el-radio",
            {
              attrs: { label: "1" },
              model: {
                value: _vm.radio,
                callback: function ($$v) {
                  _vm.radio = $$v
                },
                expression: "radio",
              },
            },
            [_vm._v("客户发起的投诉")]
          ),
          _c(
            "el-radio",
            {
              attrs: { label: "2" },
              model: {
                value: _vm.radio,
                callback: function ($$v) {
                  _vm.radio = $$v
                },
                expression: "radio",
              },
            },
            [_vm._v("我发起的投诉")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "center" }, [
        _c(
          "div",
          {
            staticClass: "centerBox",
            staticStyle: { "margin-bottom": "0.1rem" },
          },
          [
            _c("p", [_vm._v("订单编号")]),
            _c("el-input", {
              staticStyle: { width: "1.5rem", "margin-right": "0.1rem" },
              attrs: { size: "small", placeholder: "订单编号" },
              model: {
                value: _vm.input,
                callback: function ($$v) {
                  _vm.input = $$v
                },
                expression: "input",
              },
            }),
            _c("p", [_vm._v("资源名称")]),
            _c("el-input", {
              staticStyle: { width: "1.5rem", "margin-right": "0.1rem" },
              attrs: { size: "small", placeholder: "资源名称" },
              model: {
                value: _vm.input,
                callback: function ($$v) {
                  _vm.input = $$v
                },
                expression: "input",
              },
            }),
            _c("p", [_vm._v("评价时间")]),
            _c("el-date-picker", {
              staticStyle: { "margin-right": "0.1rem" },
              attrs: {
                size: "small",
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
              },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            }),
            _c("p", [_vm._v("投诉时间")]),
            _c("el-date-picker", {
              staticStyle: { "margin-right": "0.1rem" },
              attrs: {
                size: "small",
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
              },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "centerBox" },
          [
            _c("p", [_vm._v("买家昵称")]),
            _c("el-input", {
              staticStyle: { width: "1.5rem", "margin-right": "0.1rem" },
              attrs: { size: "small", placeholder: "买家昵称" },
              model: {
                value: _vm.input,
                callback: function ($$v) {
                  _vm.input = $$v
                },
                expression: "input",
              },
            }),
            _c(
              "el-checkbox-group",
              {
                model: {
                  value: _vm.checkList,
                  callback: function ($$v) {
                    _vm.checkList = $$v
                  },
                  expression: "checkList",
                },
              },
              [
                _c("el-checkbox", { attrs: { label: "待处理" } }),
                _c("el-checkbox", { attrs: { label: "处理中" } }),
                _c("el-checkbox", { attrs: { label: "已处理" } }),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-left": "auto" } },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      color: "#fff",
                      "background-color": "#e69c37",
                    },
                    attrs: { size: "small" },
                  },
                  [_vm._v("搜索")]
                ),
                _c("el-button", { attrs: { size: "small" } }, [_vm._v("重置")]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "footer",
        { staticClass: "footer" },
        [
          _c(
            "el-radio-group",
            {
              attrs: { size: "small" },
              model: {
                value: _vm.radio2,
                callback: function ($$v) {
                  _vm.radio2 = $$v
                },
                expression: "radio2",
              },
            },
            _vm._l(_vm.radio2List, function (item) {
              return _c("el-radio-button", {
                key: item,
                attrs: { label: item },
              })
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c("el-button", { attrs: { size: "small" } }, [
                _vm._v("申请平台协助"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { color: "#000" },
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", { attrs: { prop: "date", label: "订单编号" } }),
          _c("el-table-column", { attrs: { prop: "date", label: "商品类型" } }),
          _c("el-table-column", { attrs: { prop: "date", label: "商品信息" } }),
          _c("el-table-column", { attrs: { prop: "date", label: "评价时间" } }),
          _c("el-table-column", { attrs: { prop: "date", label: "评价内容" } }),
          _c("el-table-column", { attrs: { prop: "date", label: "评价图片" } }),
          _c("el-table-column", { attrs: { prop: "date", label: "评价视频" } }),
          _c("el-table-column", { attrs: { prop: "date", label: "回复人" } }),
          _c("el-table-column", { attrs: { prop: "date", label: "投诉时间" } }),
          _c("el-table-column", { attrs: { prop: "date", label: "当前状态" } }),
          _c("el-table-column", { attrs: { prop: "date", label: "说明" } }),
          _c("el-table-column", { attrs: { prop: "date", label: "操作" } }),
        ],
        1
      ),
      _c("Pagination"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }